import { SALE_ITEM_TYPES } from '../../../constants/financial';

export const ITEM_TYPES = [
    { value: SALE_ITEM_TYPES.SERVICE, label: "Serviço (Taxas, Avaliação, etc)" },
    { value: SALE_ITEM_TYPES.PRODUCT, label: "Produto Físico (Garrafa, Camisa, etc)" }
];
